module.exports = __webpack_public_path__ + "img/mountedcrane_stopped.c6d4ad65.svg";